import { datadogRum } from "@datadog/browser-rum";
import {
    getVercelEnv,
    isInCreateReactAppProductionMode
} from "config/envVariables";
import { PropsWithChildren, useEffect } from "react";

/**
 * Initializes Datadog logging.
 */
export const DataDogProvider: React.FC<PropsWithChildren> = ({ children }) => {
    // Set up telemetry
    useSetupDatadog();

    return <>{children}</>;
};

const useSetupDatadog = (): void => {
    useEffect(() => {
        if (isInCreateReactAppProductionMode()) {
            const env = getVercelEnv();

            datadogRum.init({
                applicationId: "5f1440b1-d7ab-4716-a323-59b27cbdfea5",
                clientToken: "pub9d13a9ee4906f432f908e363d5b6730e",
                site: "datadoghq.com",
                service: "nira-app",
                env,
                // version: '1.0.0',
                sampleRate: 100,
                trackInteractions: true
            });
        }
    }, []);
};
